import {useAppSelector} from '../hooks/store';
import {selectSelectedDate} from '../store/slices/selectors';
import {getUrlInfo} from '../utils/getUrlInfo';

export const useUpdateDateAndTimeQueryParam = () => {
  const selectedDate = useAppSelector(selectSelectedDate);
  const {url, searchParams} = getUrlInfo(location.href);
  const startDate = searchParams.get('date');
  if (!selectedDate) {
    return;
  }

  const isOnlyDateChanged = selectedDate !== startDate;

  if (isOnlyDateChanged) {
    updateDateQueryParam({
      url,
      date: selectedDate,
    });
  }
};

const updateDateQueryParam = ({url, date}: {url: URL; date: string}) => {
  url.searchParams.set('date', date);
  history.replaceState(null, '', url.toString());
};

export const formatTimeFrom = (timeFrom: string | null) => {
  const timeFromHour = timeFrom?.slice(0, 2);
  const timeFromMinutes = timeFrom?.slice(2, 4);
  return timeFromHour && timeFromMinutes
    ? timeFromHour?.concat(`:${timeFromMinutes}`)
    : null;
};
